export default "__VITE_ASSET__DmRY9dYQ__"